import { LD_APP_NAME } from './ldConfig';

export function buildLDContext(userInfo, ldEnv) {
  if (!userInfo || !userInfo.user_id || userInfo.user_id <= 0) {
    return null;
  }

  return {
    kind: 'user',
    key: String(userInfo.user_id),
    name: userInfo.full_name || '',
    email: userInfo.email || '',
    ldEnv: ldEnv || '',
    app: LD_APP_NAME,
  };
}

export function buildAnonymousLDContext(ldEnv) {
  return {
    kind: 'user',
    key: `anonymous-${LD_APP_NAME}`,
    anonymous: true,
    ldEnv: ldEnv || '',
    app: LD_APP_NAME,
  };
}
